import { render, staticRenderFns } from "./HistoryTransportPopup.vue?vue&type=template&id=4bb38139"
import script from "./HistoryTransportPopup.vue?vue&type=script&lang=js"
export * from "./HistoryTransportPopup.vue?vue&type=script&lang=js"
import style0 from "./HistoryTransportPopup.vue?vue&type=style&index=0&id=4bb38139&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports